import {openDialog} from '@common/ui/overlays/store/dialog-store';
import {MaterialIconSelectorDialog} from '@app/editor/icon-selector/material-icon-selector-dialog';

export async function openMaterialIconSelector(): Promise<{
  class: string;
  name: string;
} | null> {
  return await openDialog(MaterialIconSelectorDialog);
}

